import { isNil } from 'lodash';
import React from 'react';
import { FormatDateOptions, useIntl } from 'react-intl';

import messages from './messages';
import { Container, DocumentTitle, LastUpdatedDate } from './styles';

interface DocumentProps {
	children?: React.ReactNode;
	title: string;
	lastChangedDate: string;
}

const Document = ({ title, lastChangedDate, children }: DocumentProps) => {
	const { formatMessage, formatDate } = useIntl();

	function lastUpdatedOrEffective() {
		const dateFormatting: FormatDateOptions = {
			dateStyle: 'medium',
		};
		if (new Date(lastChangedDate) > new Date()) {
			return formatMessage(messages.effectiveDate, {
				date: formatDate(new Date(lastChangedDate), dateFormatting),
			});
		}
		const date = isNil(lastChangedDate) ? new Date() : new Date(lastChangedDate);
		return formatMessage(messages.lastUpdated, {
			date: formatDate(new Date(date), dateFormatting),
		});
	}

	return (
		<Container>
			<DocumentTitle>{title}</DocumentTitle>
			<LastUpdatedDate>
				<small>{lastUpdatedOrEffective()}</small>
			</LastUpdatedDate>
			{children}
		</Container>
	);
};

export default Document;
